const problems = [
  {
    title: 'What if you live longer than your money?',
    description: 'Plan for 30 years and live for 35 — running out of money in your 90s isn\'t a spreadsheet error you can fix.',
  },
  {
    title: 'A crash in year one changes everything',
    description: 'Retire into a falling market and your pot may never recover. A 30% drop in your first year of retirement does more damage than the same drop ten years in. Most projections ignore this entirely.',
  },
  {
    title: 'The wrong withdrawal order costs thousands',
    description: 'You have a SIPP, an ISA, maybe a brokerage account. Draw from the wrong one first and you could pay tens of thousands more in tax over a 30-year retirement. The right sequence depends on your pot sizes, your age, and your tax band.',
  },
  {
    title: 'Taking your State Pension too early — or too late — costs real money',
    description: 'You can start your State Pension at 66 or defer it for a higher payout later. But if you\'re already drawing your SIPP, the combined income could push you into a higher tax band. When to start depends on your other income.',
  },
  {
    title: 'Your money buys less every year',
    description: 'At just 2% inflation, today\'s £50k lifestyle costs £67k in 15 years. Over a 30-year retirement, that compounds relentlessly.',
  },
  {
    title: 'The hidden 60% tax trap',
    description: 'Under current tax rules, earn between £100,000 and £125,140 and HMRC effectively takes 60p of every extra pound. Most people discover this too late to plan around it — and it can cost thousands in avoidable tax, depending on income and timing.',
  },
];

export function ProblemSection() {
  return (
    <section className="landing-section landing-problem">
      <div className="landing-section-inner">
        <h2 className="landing-section-title">Six retirement risks your pension provider's projection doesn't model</h2>
        <div className="landing-problem-grid">
          {problems.map((p) => (
            <div key={p.title} className="landing-problem-card">
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
